// Note: this dictionary is used only for 'clickstream_component_view' type
export var viewNameDictionary = {
  '/': 'verification method modal',
  factor_selector: 'mfa verification method modal',
  'mfa-by-email': 'not in use',
  qr: 'scan qr code modal',
  timeout: "Let's try that again",
  general_error: 'mfa error modal',
  push_sent: 'push notification sent modal',
  app_push_declined: 'mfa notifications declined by app modal',
  os_push_declined: 'mfa notifications declined modal',
  px: 'px challenge'
};